<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <router-link class="btn btn-dark btn-sm" :to="{ name: 'cxc-corte-caja', params: {} }">
            <i class="fas fa-reply"></i> &nbsp;Regresar
          </router-link>
          <div class="btn-group" style="float: right;">
            <div class="dropleft">
              <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-cogs"></i> Acciones
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" data-toggle="modal" data-target="#ModalImpresiones" href="#">
                  Imprimir &nbsp;<i class="fas fa-print"></i>
                </a>
                <button
                  v-if="current.estado === 'C'"
                  class="dropdown-item"
                  @click="mostrarModalSesion(false)"
                >
                  Aceptar Corte
                  <i class="fas fa-check"></i>
                </button>
                <button
                  v-if="current.estado === 'F'"
                  class="dropdown-item"
                  @click="mostrarModalSesion(true)"
                >
                  Auditar Corte
                  <i class="fas fa-folder"></i>
                </button>
                <button
                  v-if="
                    current.estado === 'C' ||
                    current.estado === 'F' ||
                    current.estado === 'Z'
                  "
                  class="dropdown-item"
                  @click="verDetalles()"
                >
                  {{ label_mostrar_detalles }}
                  <i :class="{'fas fa-eye-slash':mostrar_detalles,'fas fa-eye':!mostrar_detalles}"></i>
                </button>
                <button v-if="current.estado === 'A'" href="#" class="dropdown-item" @click="iniciarCorte()"
                  :disabled="current.fecha_cierre != null">Realizar Corte
                  Corte <i class="fas fa-check"></i></button>
                <button v-else-if="current.estado === 'B'" href="#" class="dropdown-item" @click="validarCorte()"
                  :disabled="current.fecha_cierre != null">Finalizar
                  Corte <i class="fas fa-check"></i></button>

                <a type="button" data-toggle="modal" data-target="#modalLog" class="dropdown-item" href="#">
                  Ver Modificaciones &nbsp;<i class="fas fa-history"></i>
                </a>
                <a @click="generarPolizaDeCierre" class="dropdown-item" href="#">Generar Póliza de Cierre <i
                    class="fas fa-balance-scale"></i></a>
              </div>
            </div>
          </div>
          <br><br>
          <div class="element-wrapper">
            <div class="element-box">
              <h5 v-if="!current.codigo" class="form-header">
                Proceso de caja #{{ current.numero }}
                <span
                 :class="{
                  'badge badge-success':current.estado === 'A',
                  'badge badge-warning':current.estado === 'B',
                  'badge badge-blue':current.estado === 'C',
                  'badge badge-dark':current.estado === 'F',
                  'badge badge-danger':current.estado === 'Z',
                   }"
                >
                  {{ current.estado_corte }}
                </span>
              </h5>
              <small style="color: gray" class="font-weight-bold" v-if="current.estado === 'F' || current.estado === 'Z'">
                Información del proceso de caja:
                <br>
                <div v-if="current.estado === 'F' || current.usuario_acepta_corte ">
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  El proceso de caja ha sido aceptado por el usuario {{ current.usuario_acepto }} el día {{ current.fecha_aceptado | moment("DD/MM/YYYY HH:MM") }}.
                </div>
                <br />
                <div v-if="current.estado === 'Z' && current.usuario_audita">
                  <i style="color: gray" class="fas fa-info-circle"></i>
                  El proceso de caja ha sido auditado por el usuario {{ current.usuario_audito }} el día {{ current.fecha_auditado | moment("DD/MM/YYYY HH:MM") }}.
                </div>
              </small><br>
              <div class="row">
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Tienda</label>
                    <input v-model="current.tienda" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Caja #</label>
                    <input v-model="current.caja" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Fecha/Hora de Apertura</label>
                    <input v-model="current.fecha_apertura" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Fecha/Hora de Cierre</label>
                    <input v-model="current.fecha_cierre" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
              </div>
              <br>
              <!--Sección de Información Complementaria-->
              <h6 style="color: #6c6384;">Información Complementaria</h6>
              <div class="row">
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Cajero</label>
                    <input v-model="current.usuario" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Factura Serie</label>
                    <input v-model="current.serie_fact" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Recibo Serie</label>
                    <input v-model="current.serie_rc" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Monto de Apertura</label>
                    <input v-model="current.monto_apertura" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
              </div>
              <div class="row" v-if="current.estado === 'C' || current.estado === 'F' || current.estado === 'Z'">
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label>Vuelto</label>
                    <input v-model="currentResumen.VUELTO" class="form-control" autofocus="autofocus"
                      readonly placeholder type="text"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label>Venta Neta</label>
                    <input v-model="currentResumen.TOTAL_SISTEMA" class="form-control" autofocus="autofocus"
                      readonly placeholder type="text"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label>Venta Bruta</label>
                    <input v-model="currentResumen.VENTA" class="form-control" autofocus="autofocus"
                      readonly placeholder type="text"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label>Venta Crédito</label>
                    <input v-model="currentResumen.VENTA_CREDITO" class="form-control" autofocus="autofocus"
                      readonly placeholder type="text"
                    />
                  </div>
                </div>
              </div>
              <!-- Fin de Sección Complementaria -->
              <br />
              <div class="alert" style="background-color: #cbb5ff;" role="alert" v-if="current.fecha_cierre">
                <h4 class="alert-heading" style="color: #3e3949;">Observaciones:</h4>
                <p class="text-dark font-weight-bold"></p>
                <h6 class="fas fa-info text-info" style="font-size: 12px;"></h6>
                <span style="color: #5b5170; font-size: 15px;">&nbsp;<b>El corte de caja ha sido finalizado!</b></span>
                <br>&nbsp;
                <span v-if="current.estado === 'C'" class="text-dark" style="font-size: 14px; color: #3e3949;">
                  Las modificaciones posteriores a su finalización están restringidas!
                  <br>
                  &nbsp; Si desea hacer una
                  corrección puede solicitar corrección, luego el jefe, coordinador de cajas
                  o encargado de turno debe aceptar la solicitud en el botón ver solicitudes
                </span>
                <span v-else-if="current.estado === 'F'" class="text-dark" style="font-size: 14px; color: #3e3949;">
                  El proceso de caja ya ha sido finalizado y aceptado!
                  <br>
                  &nbsp; Ya no se permiten hacer más correcciones.
                </span>
                <span v-else-if="current.estado === 'Z'" class="text-dark" style="font-size: 14px; color: #3e3949;">
                  El proceso de caja ya ha sido auditado!
                  <br>
                  &nbsp;
                </span>

                <p class="mb-0"></p>
                <i class="fas fa-check-circle"
                  style="font-size: 130px; position: absolute; right: 1px; top: 65px; transform: translateY(-50%); opacity: 0.1; filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3)); z-index: 0;"></i>
              </div>
              <br>
              <div class="alert alert-warning" role="alert" v-if="sobrantes != null && current.estado === 'C'">
                <h4 class="alert-heading">Sobrantes</h4>
                <span class="text-dark" style="font-size: 14px; color: #3e3949;">
                  Existen sobrantes en las formas de pago: {{ sobrantes }}
                </span>
              </div>
              
              <div class="alert alert-danger" role="alert" v-if="faltantes != null && current.estado === 'C'">
                <h4 class="alert-heading">Faltantes</h4>
                <span class="text-dark" style="font-size: 14px; color: #3e3949;">
                  Existen faltantes para las formas de pago: {{ faltantes }}
                </span>
              </div>
              
              <div class="alert alert-info" role="alert" v-if="current.poliza_cierre">
                <h4 class="alert-heading">Poliza de cierre generada</h4>
              </div>
              <br>
              <!-- INICIO DE LA TABLA DE DETALLE -->
              <div class="table-responsive" v-if="current.estado === 'B' || mostrar_detalles">
                <h5 class="form-header">Detalles de Corte</h5>
                <table v-if="current.estado === 'B' || mostrar_detalles" class="table table-bordered table-striped">
                  <caption>
                    Estados para detalles de corte:
                    <div
                        class="mr-1 status-pill green"
                        data-title="Activo"
                        data-toggle="tooltip"
                      ></div>Activo
                      <div
                        class="ml-2 mr-1 status-pill blue"
                        data-title="Cerrado"
                        data-toggle="tooltip"
                      ></div>Cerrado
                      <div
                        class="ml-2 mr-1 status-pill red"
                        data-title="Anulado"
                        data-toggle="tooltip"
                      ></div>Anulado
                  </caption>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Forma de pago</th>
                      <th>Responsable</th>
                      <th class="text-center">Tipo</th>
                      <th class="text-right">Total</th>
                      <th class="text-center">Estado</th>
                      <!--<th class="text-center" v-if="current.fecha_cierre == null">Acciones</th>-->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.cxccierredetalle_set" v-bind:key="detalle.id" :class="{'table-success':detalle.tipo_detalle === 'C','table-danger':detalle.tipo_detalle === 'R'}">
                      <td>{{ detalle.fecha | moment("DD/MM/YYYY HH:MM") }}</td>
                      <td>{{ detalle.forma_pago }}</td>
                      <td>{{ detalle.usuario.name }}</td>
                      <td class="text-left" v-if="detalle.tipo_detalle === 'R'">Retiro</td>
                      <td class="text-left" v-else>Corte</td>
                      <td class="text-right" v-if="detalle.total<0">Q {{ detalle.total*-1 }}</td>
                      <td class="text-right" v-else>Q {{ detalle.total }}</td>
                      <td class="text-center">
                        <div
                          :class="{
                            'status-pill green':detalle.estado === 'A',
                            'status-pill blue':detalle.estado === 'C',
                            'status-pill red':detalle.estado === '9',
                          }"
                          :data-title="detalle.estado"
                          data-toggle="tooltip"
                        ></div>   
                      </td>
                      <!-- <td class="text-right" v-if="current.fecha_cierre == null">
                        <button @click="eliminarLinea(detalle)" class="btn btn-danger btn-sm">
                          <i class="fas fa-trash"></i> &nbsp; Eliminar
                        </button>
                      </td>-->
                    </tr>
                  </tbody>
                </table>
              </div>
              
            <!-- FIN DE LA TABLA DE DETALLE DE CORTE-->
            <!-- INCIO DE LA TABLA DE RESUMEN DE CORTE -->
            <div class="table-responsive"
              v-if="
                current.estado === 'C' ||
                current.estado === 'F' ||
                current.estado === 'Z'
              "
            >
              <h5 class="form-header">Resumen de Cierre</h5>
              
              <table
                :class="{
                  'table table-bordered table-striped loader-wrapper': !resumenCargado,
                  'table table-bordered table-striped': resumenCargado,
                }">
                  <LoaderComponent
                    :condicion="resumenCargado"
                  ></LoaderComponent>
                <caption>
                  Colores para resumen del corte:
                  <div
                      class="mr-1 status-pill green"
                      data-title="Cuadrado"
                      data-toggle="tooltip"
                    ></div>Cuadrado
                    <div
                      class="ml-2 mr-1 status-pill yellow"
                      data-title="Sobrante"
                      data-toggle="tooltip"
                    ></div>Sobrante
                    <div
                      class="ml-2 mr-1 status-pill red"
                      data-title="Faltante"
                      data-toggle="tooltip"
                    ></div>Faltante
                </caption>
                <thead>
                  <tr>
                    <th class="text-left">Forma de pago</th>
                    <th class="text-right">Corte del sistema</th>
                    <th class="text-right">Corte del cajero</th>
                    <th class="text-right">Diferencia</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left">Efectivo</td>
                    <td class="text-right">Q {{ currentResumen.EFECTIVO }}</td>
                    <td class="text-right">Q {{ currentResumen.CAJERO_EFECTIVO }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="text-left">Retiro en Efectivo</td>
                    <td class="text-right"></td>
                    <td class="text-right">Q {{ currentResumen.RETIRO_EFECTIVO }}</td>
                    <td class="text-right"></td>
                  </tr>
                  <tr
                    :class="{
                      'table-success':currentResumen.DIFERENCIA_EFECTIVO === 0,
                      'table-danger':currentResumen.DIFERENCIA_EFECTIVO < 0,
                      'table-warning':currentResumen.DIFERENCIA_EFECTIVO > 0
                    }"
                    style="border-top: 2px solid #000 !important;"
                  >
                    <td class="text-left">Subtotal de Efectivo</td>
                    <td class="text-right">Q {{ currentResumen.EFECTIVO }}</td>
                    <td class="text-right">Q {{ currentResumen.SUMA_EFECTIVO }}</td>
                    <td class="text-right">Q {{ currentResumen.DIFERENCIA_EFECTIVO }}</td>
                  </tr>
                  <tr
                    :class="{
                      'table-success':currentResumen.DIFERENCIA_TARJETA === 0,
                      'table-danger':currentResumen.DIFERENCIA_TARJETA < 0,
                      'table-warning':currentResumen.DIFERENCIA_TARJETA > 0
                    }"
                  >
                    <td class="text-left">Tarjeta</td>
                    <td class="text-right">Q {{ currentResumen.TARJETA_CREDITO }}</td>
                    <td class="text-right">Q {{ currentResumen.CAJERO_TARJETA_CREDITO }}</td>
                    <td class="text-right">Q {{ currentResumen.DIFERENCIA_TARJETA }}</td>
                  </tr>
                  <tr
                    :class="{
                      'table-success':currentResumen.DIFERENCIA_CHEQUE === 0,
                      'table-danger':currentResumen.DIFERENCIA_CHEQUE < 0,
                      'table-warning':currentResumen.DIFERENCIA_CHEQUE > 0
                    }"
                  >
                    <td class="text-left">Cheques</td>
                    <td class="text-right">Q {{ currentResumen.CHEQUE }}</td>
                    <td class="text-right">Q {{ currentResumen.CAJERO_CHEQUE }}</td>
                    <td class="text-right">Q {{ currentResumen.DIFERENCIA_CHEQUE }}</td>
                  </tr>
                  <tr
                    :class="{
                      'table-success':currentResumen.DIFERENCIA_CERT === 0,
                      'table-danger':currentResumen.DIFERENCIA_CERT < 0,
                      'table-warning':currentResumen.DIFERENCIA_CERT > 0
                    }"
                  >
                    <td class="text-left">Certificados</td>
                    <td class="text-right">Q {{ currentResumen.CERT }}</td>
                    <td class="text-right">Q {{ currentResumen.CAJERO_CERT }}</td>
                    <td class="text-right">Q {{ currentResumen.DIFERENCIA_CERT }}</td>
                  </tr>
                  <tr
                    :class="{
                      'table-success':currentResumen.DIFERENCIA_DEPOSITO === 0,
                      'table-danger':currentResumen.DIFERENCIA_DEPOSITO < 0,
                      'table-warning':currentResumen.DIFERENCIA_DEPOSITO > 0
                    }"
                  >
                    <td class="text-left">Depósito</td>
                    <td class="text-right">Q {{ currentResumen.DEPOSITO }}</td>
                    <td class="text-right">Q {{ currentResumen.CAJERO_DEPOSITO }}</td>
                    <td class="text-right">Q {{ currentResumen.DIFERENCIA_DEPOSITO }}</td>
                  </tr>
                  <tr
                    :class="{
                      'table-success':currentResumen.DIFERENCIA_PLANILLA === 0,
                      'table-danger':currentResumen.DIFERENCIA_PLANILLA < 0,
                      'table-warning':currentResumen.DIFERENCIA_PLANILLA > 0
                    }"
                  >
                    <td class="text-left">Planilla</td>
                    <td class="text-right">Q {{ currentResumen.PLANILLA }}</td>
                    <td class="text-right">Q {{ currentResumen.CAJERO_PLANILLA }}</td>
                    <td class="text-right">Q {{ currentResumen.DIFERENCIA_PLANILLA }}</td>
                  </tr>
                 <!--
                  <tr
                    :class="{
                      'table-success':currentResumen.DIFERENCIA_DEVEFEC === 0,
                      'table-danger':currentResumen.DIFERENCIA_DEVEFEC < 0,
                      'table-warning':currentResumen.DIFERENCIA_DEVEFEC > 0
                    }"
                  >
                    <td class="text-left">Devolución Efectivo</td>
                    <td class="text-right">Q {{ currentResumen.DEVEFEC }}</td>
                    <td class="text-right">Q {{ currentResumen.CAJERO_DEVEFEC }}</td>
                    <td class="text-right">Q {{ currentResumen.DIFERENCIA_DEVEFEC }}</td>
                  </tr> 
                 -->
                  <tr>
                    <td class="text-left">Notas Aplicadas</td>
                    <td class="text-right">Q {{ currentResumen.NC }}</td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <tr>
                    <td class="text-left">Notas Ingresadas</td>
                    <td class="text-right"></td>
                    <td class="text-right">Q {{ currentResumen.CAJERO_NC }}</td>
                    <td class="text-right"></td>
                  </tr>
                  <tr style="border-top: 2px solid #000 !important;">
                    <td class="text-left">Subtotal Formas de Pago</td>
                    <td class="text-right"><strong>Q {{ currentResumen.SUBTOTAL_SISTEMA }}</strong></td>
                    <td class="text-right"><strong>Q {{ currentResumen.SUBTOTAL_CAJERO }}</strong></td>
                    <td class="text-right"><strong>Q {{ currentResumen.DIFERENCIA_SUBTOTALES }}</strong></td>
                  </tr>
                  <tr>
                    <td class="text-left">Notas No Aplicadas</td>
                    <td class="text-right">Q {{ currentResumen.NC_NA }}</td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <tr>
                    <td class="text-left">Notas Emitidas</td>
                    <td class="text-right">Q {{ currentResumen.NOTA }}</td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <tr>
                    <td class="text-left">Devoluciones Efectivo</td>
                    <td class="text-right"></td>
                    <td class="text-right" v-if="currentResumen.DEVOLUCION_EFECTIVO>0">Q -{{ currentResumen.DEVOLUCION_EFECTIVO }}</td>
                    <td class="text-right" v-else>Q {{ currentResumen.DEVOLUCION_EFECTIVO }}</td>
                    <td class="text-right"></td>
                  </tr>
                </tbody>
                <tfoot class="table-group-divider">
                  <tr
                    :class="{
                      'table-success':currentResumen.DIFERENCIA_TOTALES === 0,
                      'table-danger':currentResumen.DIFERENCIA_TOTALES < 0,
                      'table-warning':currentResumen.DIFERENCIA_TOTALES > 0
                    }"
                    style="border-top: 4px double #000 !important;font-weight: bold;"
                  >
                    <td class="fw-bold">Total</td>
                    <td class="text-right"><strong>Q {{ currentResumen.TOTAL_SISTEMA }}</strong></td>
                    <td class="text-right"><strong>Q {{ currentResumen.TOTAL_CAJERO }}</strong></td>
                    <td class="text-right"><strong>Q {{ currentResumen.DIFERENCIA_TOTALES }}</strong></td>
                  </tr>
                </tfoot>
              </table>
                
              <!-- FIN DE LA TABLA DE RESUMEN DE CORTE -->
            </div>
          </div>
        </div>
      </div>

      <div id="botonera" class="ml-2 row" v-if="current.id != null">
        <div v-if="current.estado === 'B'"  class="col">
          <button type="button" data-toggle="modal"
            data-target="#modalAgregarDetalleCierre" class="btn btn-secondary btn-md">
            Agregar Detalle &nbsp;<i class="fas fa-plus"></i>
          </button>
        </div>
        <div v-if="current.fecha_cierre == null" class="col">
          <button type="button" data-toggle="modal"
            data-target="#exampleModal1" class="btn btn-primary btn-md">
            Retiro de Efectivo &nbsp;<i class="fas fa-cash-register"></i>
          </button>
        </div>
        <div v-if="current.estado === 'C'" class="row">
          <div class="col mb-2">
            <button  type="button" data-toggle="modal" data-target="#solicitudCorreccionModal"
              class="btn btn-blue btn-md">
              Solicitar Corrección &nbsp;<i class="fas fa-pen"></i>
            </button>
          </div>
          <!--<div class="col mb-2">
            <button type="button" data-toggle="modal" data-target="#exampleModal"
              class="btn btn-blue btn-md">
              Realizar Corrección &nbsp;<i class="fas fa-check-circle"></i>
            </button>
          </div>-->
          <div class="col mb-2">
            <button
              type="button"
              data-toggle="modal"
              data-target="#solicitudesCorreccionModal"
              class="btn btn-blue btn-md"
            >
              Ver Solicitudes &nbsp;<i class="fas fa-file"></i>
            </button>
          </div>
        </div>
        
      </div>
      
      <SolicitudTableComponent
        :permisos="permisos"
        :solicitudes="currentSolicitudes"
        @refreshSolicitudes="refreshSolicitudes"
        @refreshCurrent="refreshCurrent"
        :estados="estadosSolicitudes"
      ></SolicitudTableComponent>
    </div>
      <!-- Modal añadir detalle a Corte-->
      <div class="modal fade" id="modalAgregarDetalleCierre" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Seleccione el campo a añadir:
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <label>Forma de Pago</label>
                <select @change="mostrarCuadreEfectivo" type="text" class="form-control" v-model="currentDetalle.forma_pago">
                  <option v-for="(detalle, key) in formas_pago" :value="detalle.id" :key="key">
                    {{ detalle.nombre }}
                  </option>
                </select>
              </div>
              <br />
              <div class="col-12">
                <label>Total</label>
                <input id="total" type="text" class="form-control" v-model="currentDetalle.total" />
              </div>
              
              <div id="cuadre" class="row mt-2" hidden>
                <br>
                <div class="col-6">
                  <h6>Billetes</h6>
                  <div v-for="tipo_efectivo in tipos_efectivo">
                    <div v-if="tipo_efectivo.tipo_moneda === 'Billete'">
                      <label>{{ tipo_efectivo.divisa.simbolo }} {{ tipo_efectivo.denominacion }}</label>
                      <input
                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                        onkeyup="if(this.value<0){this.value= this.value * -1}"
                        @change="calcularTotal()"
                        :data-denominacion="tipo_efectivo.denominacion"
                        min="0"
                        type="number"
                        name="montos"
                        class="form-control"
                        value="0"
                      />
                    </div>
                  </div>
                </div>
                <br>
                <div class="col-6">
                  <h6>Monedas</h6>
                  <div v-for="tipo_efectivo in tipos_efectivo">
                    <div v-if="tipo_efectivo.tipo_moneda === 'Moneda'">
                      <label>{{ tipo_efectivo.divisa.simbolo }} {{ tipo_efectivo.denominacion }}</label>
                      <input
                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                        onkeyup="if(this.value<0){this.value= this.value * -1}"
                        @change="calcularTotal()"
                        :data-denominacion="tipo_efectivo.denominacion"
                        min="0"
                        type="number"
                        name="montos"
                        class="form-control"
                        value="0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
                <i class="fas fa-door-open"></i> Cerrar
              </button>
              <button type="button" @click="agregarDetalleAfter(currentDetalle)" class="btn btn-info">
                <i class="fas fa-save"></i> Guardar Detalle
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin de Modal Añadir detalle a Corte -->
      <!-- Modal Corrección Corte-->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="exampleModalLabel">
                Agregar detalle de cierre despues de corte
                <i class="fas fa-cash-register"></i>
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <label>Forma de Pago</label>
                <select type="text" class="form-control" v-model="currentDetalle.forma_pago">
                  <option v-for="(detalle, key) in formas_pago" :value="detalle.id" :key="key">
                    {{ detalle.nombre }}
                  </option>
                </select>
              </div>
              <br />
              <div class="col-12">
                <label>Total</label>
                <input type="text" class="form-control" v-model="currentDetalle.total" />
                <small v-bind:class="{
                  'text-danger':
                    currentDetalle.errors.total &&
                    currentDetalle.errors.total.length > 0,
                }"></small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
                <i class="fas fa-door-open"></i> Cerrar
              </button>
              <button type="button" @click="agregarDetalle(currentDetalle)" class="btn btn-info">
                <i class="fas fa-save"></i> Guardar Detalle
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin de Modal Corrección Corte-->
      <!-- Inicio Modal Solicitud Corrección Corte-->
      <div class="modal fade" id="solicitudCorreccionModal" tabindex="-1" role="dialog" aria-labelledby="solicitudCorreccionModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="solicitudCorreccionModalLabel">
                Agregar solicitud para corrección del corte
                <i class="fas fa-cash-register"></i>
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <label class="form-label">Motivo de la solicitud *</label>
                <select id="motivoSolicitud" type="text" class="form-control" v-model="solicitudCorreccion.motivo">
                  <option v-for="motivo in motivos_correccion" :value="motivo.llave" :key="motivo.llave">
                    {{ motivo.valor }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <label>Tipo de Corrección *</label>
                <select id="tipo_correccion" type="text" class="form-control" v-model="solicitudCorreccion.tipo_correccion">
                  <option v-for="tipo in tipos_correccion" :value="tipo.llave" :key="tipo.llave">
                    {{ tipo.valor }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <label>Forma de Pago *</label>
                <select id="forma_pago" type="text" class="form-control" v-model="solicitudCorreccion.forma_pago">
                  <option v-for="(detalle, key) in formas_pago" :value="detalle.id" :key="key">
                    {{ detalle.nombre }}
                  </option>
                </select>
              </div>
              <div class="col-12" v-if="solicitudCorreccion.forma_pago === 'EFECTIVO'">
                <label>Tipo de Detalle de Corte *</label>
                <select id="tipo_detalle_corte" type="text" class="form-control" v-model="solicitudCorreccion.tipo_detalle_corte">
                  <option v-for="tipo in tipos_detalle_corte" :value="tipo.llave" :key="tipo.llave">
                    {{ tipo.valor }}
                  </option>
                </select>
              </div>
              <br />
              <div class="col-12">
                <label>Total *</label>
                <input id="cantidad_solicitud" type="number" class="form-control" v-model="solicitudCorreccion.cantidad" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
                <i class="fas fa-door-open"></i> Cerrar
              </button>
              <button type="button" @click="guardarSolicitudCorreccion()" class="btn btn-info">
                <i class="fas fa-save"></i> Guardar Detalle
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin de Modal Corrección Corte-->
      <div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Agregar retiro de efectivo
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <label>Total retiro</label>
                <input type="number" class="form-control" v-model="currentDetalle.total" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cerrar
              </button>
              <button type="button" @click="agregarRetiroEfectivo(currentDetalle)" class="btn btn-primary">
                Guardar Detalle
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin Modal -->
      <!-- Modal de Impresiones -->
      <div class="modal fade" id="ModalImpresiones" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Impresiones
                <br>
                Corte de Caja
              </h5>
              <button class="btn btn-danger btn-sm" @click="cerrarModal()" style="position: relative; z-index: 9999;">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body"
              style="position: relative; display: flex; flex-direction: column; align-items: center;">
              <i class="fas fa-print"
                style="font-size: 350px; position: absolute; right: 1px; top: -10px; transform: translateY(-50%); opacity: 0.1; filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3)); z-index: 0;"></i>
              <div
                style="display: flex; justify-content: space-around; align-items: flex-start; width: 100%; margin-top: 20px; position: relative; z-index: 1;">
                <div style="margin: 10px; text-align: center; flex: 1;" @click="imprimirCorte">
                  <label style="color: #000;">Corte de Caja</label>
                  <div id="corte_caja" class="glow-on-hover" title="Imprimir Corte de Caja"
                    style="height: 80px; background-color: #000000; color: white; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 15px;">
                    <i class="fas fa-cash-register" style="font-size: 50px;"></i>
                  </div>
                </div>
                <div style="margin: 10px; text-align: center; flex: 1;" @click="imprimirRetiroEfectivo">
                  <label style="color: #000;">Retiros</label>
                  <div id="retiro_efectivo" class="glow-on-hover" title="Imprimir Constancia de Retiro"
                    style="height: 80px; background-color: #000000; color: white; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 15px;">
                    <i class="fas fa-money-bill-wave" style="font-size: 50px;"></i>
                  </div>
                </div>
                <div style="margin: 10px; text-align: center; flex: 1;" @click="imprimirDetalleVenta">
                  <label style="color: #000;">Ventas</label>
                  <div id="detalle_ventas" class="glow-on-hover" title="Imprimir Detalle de Ventas"
                    style="height: 80px; background-color: #000000; color: white; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 15px;">
                    <i class="fas fa-chart-line" style="font-size: 50px;"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
            </div>
          </div>
        </div>
      </div>
      <!-- Fin Modal de Impresiones -->
    </div>
    <div v-if="current.id">
      <LogModalComponent modulo="cxc" transac="corte-caja" :id="current.id" />
    </div>
    <div class="modal fade" id="usuarioAceptaCorteModal" tabindex="-1" aria-labelledby="usuarioAceptaCorteModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="usuarioAceptaCorteModalLabel">Usuario de confirmación</h1>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="recipient-name" class="col-form-label">Usuario:</label>
                <input type="text" class="form-control" v-model="usuario.username">
              </div>
              <div class="mb-3">
                <label for="message-text" class="col-form-label">Contraseña:</label>
                <input type="password" class="form-control" v-model="usuario.password">
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="confirmarSesion()"
            >
              Confirmar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CorteCajaService from "@/services/cxc/CorteCajaService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import LogModalComponent from "@/components/commons/LogModalComponent";
import SolicitudCorreccionService from "@/services/cxc/SolicitudCorreccionService";
import SolicitudTableComponent from "@/components/cxc/corte_caja/SolicitudTableComponent.vue";
import AuthService from "@/services/AuthService";
import LoaderComponent from "@/components/commons/LoaderComponent.vue";

export default {
  components: { LogModalComponent,SolicitudTableComponent,LoaderComponent },
  data() {
    return {
      resumenCargado: false,
      roles:{
        ADMINISTRADOR:0,
        AUDITOR:1,
        ENCARGADO:2,
      },
      permisos:{
        JEFES:3,
        SUBJEFES_ASISTENTES:4,
        CONTA:6,
        ADMINISTRADOR:15,
      },
      usuario:{
        id:null,
        username:null,
        password:null,
        grupos:null,
        confirmado:false,
        rol:null,
      },
      errors: {
        username: [],
        password: [],
        non_field_errors: []
      },
      currentSolicitudes:null,
      tipos_correccion:[],
      tipos_detalle_corte:[],
      motivos_correccion:[],
      estadosSolicitudes:[],
      mostrar_detalles:false,
      label_mostrar_detalles:"Mostrar Detalles",
      solicitudCorreccion:{
        motivo: "",
        tipo_detalle_corte: null,
        tipo_correccion: "",
        cantidad: 0,
        forma_pago: null,
        corte_caja: null,
      },
      auditar:false,
      faltantes: null,
      sobrantes: null,
      formas_pago: [],
      currentResumen: {
        errors: [],
      },
      currentDetalle: {
        total:0,
        forma_pago:"CERT",
        agregado_desde_frontend: true,
      },
      currentDetalle: {
        total:0,
        forma_pago:"CERT",
        errors: [],
      },
      current: {
        errors: {},
      },
      tipos_efectivo:[],
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (self.$route.params.id) {
      this.refreshCurrent();
    }
    self.refreshFormasPago();
    self.getTipoEfectivo();
    self.getTipoCorrecciones(); // Obtiene los tipos de correcciones
    self.getTipoDetalleCorte(); // Obtiene los tipos de detalles
    self.refreshSolicitudes(); // Refresca las solicitudes de la tabla
    self.getEstadosSolicitudes(); // Obtiene los estados de las solicitudes
    self.getMotivosCorreccion(); // Obtiene los motivos de corrección
  },
  methods: {
    getMotivosCorreccion(){
      /* Función que obtiene los motivos de corrección para la solicitud */
      let self = this;
      SolicitudCorreccionService.getActionSinId('lista_motivos') // Se ejecuta del Service una action del backend sin el id
       .then((response) => {
          self.motivos_correccion = response.data; // Se almacena la data obtenida
        })
    },
    getEstadosSolicitudes(){
      /* Función que obtiene los estados de solicitudes */
      let self = this;
      SolicitudCorreccionService.getActionSinId('lista_estados')
       .then((response) => {
          self.estadosSolicitudes = response.data;
        });
    },
    refreshSolicitudes(){
      /* Función para refrescar la información de las solicitudes */
      let self = this;
      SolicitudCorreccionService.fetch({'corte_caja':self.$route.params.id})
       .then((response) => {
          self.currentSolicitudes = response.data;
        });
    },
    getTipoDetalleCorte(){
      /* Función que obtiene los tipos de detalles de corte */
      let self = this;
      SolicitudCorreccionService.getActionSinId('lista_tipo_detalle_corte')
       .then((response) => {
          self.tipos_detalle_corte = response.data;
        });
    },
    getTipoCorrecciones(){
      /* Función que obtiene los tipos de correcciones */
      let self = this;
      SolicitudCorreccionService.getActionSinId('lista_tipo_correcciones')
       .then((response) => {
          self.tipos_correccion = response.data;
        });
    },
    getResumen(){
      /* Función que obtiene el resumen del corte de caja */
      let self = this;
      CorteCajaService.getAction(self.$route.params.id,'obtener_resumen_corte_caja')
       .then((response) => {
          self.currentResumen = response.data;
          self.resumenCargado = true;
          self.currentResumen.errors = [];
        });
    },
    getTipoEfectivo(){
      /* Función que obtiene los tipos de efectivo */
      let self = this;
      DynamicService.fetch("cat","tipo-efectivo")
       .then((response) => {
          self.tipos_efectivo = response.data;
        });
    },
    refreshCurrent() {
      let self = this;
      CorteCajaService.getById(self.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.caja_id = response.data.caja.id;
        self.current.tienda_id = response.data.tienda.codigo;
        self.current.serie_fact = response.data.caja.serie_fact;
        self.current.serie_rc = response.data.caja.serie_rc;
        self.current.tienda = response.data.tienda.nombre;
        self.current.caja = response.data.caja.caja;
        self.current.usuario = response.data.usuario.name;
        if (self.current.fecha_cierre) {
          self.current.fecha_cierre = moment(self.current.fecha_cierre).format(
            "DD/MM/YYYY HH:mm"
          );
        };
        if (self.current.fecha_apertura) {
          self.current.fecha_apertura = moment(self.current.fecha_apertura).format(
            "DD/MM/YYYY HH:mm"
          );
        }
        self.current.errors = [];
      });
      self.obtenerFaltantesSobrantes();
      self.getResumen();
    },
    obtenerFaltantesSobrantes() {
      let self = this;
      CorteCajaService.getAction(self.$route.params.id,'obtener_faltantes_sobrantes')
      .then(response =>{
        let data = response.data;
        let sobrantes = "";
        let faltantes = "";
        sobrantes = data.sobrantes;
        faltantes = data.faltantes;
        self.sobrantes = Object.keys(sobrantes).length === 0 ? null : String(sobrantes).replace("[","").replace("]","");
        self.faltantes = Object.keys(faltantes).length === 0 ? null : String(faltantes).replace("[","").replace("]","");
      });
    },
    refreshFormasPago() {
      DynamicService.fetch("cat", "forma-pago").then((response) => {
        this.formas_pago = response.data.results;
      });
    },
    agregarRetiroEfectivo(currentDetalle) {
      if (this.currentDetalle.total < 1){this.$toast.warning("La cantidad debe ser mayor a cero.","Aviso",{position: 'topRight'});return;}
      this.currentDetalle.forma_pago = "EFECTIVO";
      this.currentDetalle.total = this.currentDetalle.total*-1;
      DynamicService.postAction(
        "cxc",
        "corte-caja",
        this.current.id,
        "agregar_retiro_efectivo",
        currentDetalle
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar retiro de efectivo",
            "realizado correctamente"
          );
          this.refreshCurrent();
          $("#exampleModal1").modal("hide");
          this.currentDetalle.total = 0;
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Agregar retiro de efectivo",
            errors.response.data.total
          );
        });
    },
    clearDataDetalle() {
      let self = this;
      self.currentDetalle.forma_pago = "";
      self.currentDetalle.total = "";
    },
    agregarDetalle(currentDetalle) {
      DynamicService.postAction(
        "cxc",
        "corte-caja",
        this.current.id,
        "agregar_detalle_despues_cierre",
        currentDetalle
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar detalle de corte",
            "realizado correctamente"
          );
          this.refreshCurrent();
          this.clearDataDetalle();
          $("#exampleModal").modal("hide");
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Agregar detalle de corte",
            errors.response.data.detail
          );
        });
    },
    agregarDetalleAfter(currentDetalle) {

      let total = document.querySelector("#total").value;
      if(this.currentDetalle.forma_pago === ""){this.$toast.warning("No se seleccionó ninguna forma de pago.","Aviso",{position: 'topRight'});return;}
      if(total < 1){this.$toast.warning("La cantidad debe ser mayor a cero.","Aviso",{position: 'topRight'});return;}
      DynamicService.postAction(
        "cxc",
        "corte-caja",
        this.current.id,
        "agregar_detalle_cierre",
        currentDetalle
      )
        .then((response) => {
          this.clearDataDetalle();
          Notifications.alert.success(
            "Agregar detalle de corte",
            "realizado correctamente"
          );
          this.refreshCurrent();
          $("#modalAgregarDetalleCierre").modal("hide");
        })
        .catch((errors) => {
          if (errors.response.data.detail){
          Notifications.alert.error(
            "Agregar detalle de corte",
            errors.response.data.detail
          );
          } else {
            Notifications.alert.error(
              "Agregar detalle de corte",
              "Ocurrio un error inesperado."
            );
          }
        });
    },
    eliminarLineaAfter(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar linea",
        "¿Esta Seguro?",
        " ",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja",
            self.current.id,
            "eliminar_detalle_cierre",
            detalle
          )
            .then((response) => {
              Notifications.alert.success(
                "eliminar linea",
                "realizado correctamente"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              if (errors.response) {
                Notifications.alert.error(
                  "Eliminar Linea",
                  errors.response.data.detail
                );
              }
            });
        }
      );
    },
    eliminarLinea(detalle) {
      let self = this;
      if (!this.current.fecha_cierre) {
        this.eliminarLineaAfter(detalle);
        return;
      }
      Notifications.alert.confirm(
        "Eliminar linea",
        "¿Esta Seguro?",
        " ",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja",
            self.current.id,
            "eliminar_detalle_despues_cierre",
            detalle
          )
            .then((response) => {
              Notifications.alert.success(
                "eliminar linea",
                "realizado correctamente"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              if (errors.response) {
                Notifications.alert.error(
                  "Eliminar Linea",
                  errors.response.data.detail
                );
              }
            });
        }
      );
    },
    iniciarCorte(){
      let self = this;
      let detail = "";
      Notifications.alert.confirm(
        "Realizar Corte",
        "Está a punto de iniciar el corte de caja, ¿Desea continuar?",
        "Si",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja",
            self.current.id,
            "colocar_en_espera",
          )
            .then((response) => {
              detail = response.data.detail;
              Notifications.alert.success(detail);
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("No se pudo Finalizar", error.response.data.detail);
            });
        }
      )
    },
    validarCorte(){
      /* Función que valida el corte de caja */
      let self = this;
      let detail = "";
      
      DynamicService.postAction(
        "cxc",
        "corte-caja",
        self.current.id,
        "validar_corte",
      )
      .then((response) => {
        detail = response.data.detail;
        if (response.status === 200) {
          self.finalizarCorte();
        }
      })
      .catch((error) => {
        if (error.response.data.code === "dato_faltante_en_corte"){Notifications.alert.error("Advertencia", error.response.data.detail);}
        else{self.finalizarCorte();}
      });
    },
    finalizarCorte() {
      let self = this;
      Notifications.alert.confirm(
        "Cerrar Corte",
        "Está a punto de finalizar el presente corte de caja, ¿Desea continuar?",
        "Si, Finalizar",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja",
            self.current.id,
            "cerrar_corte",
          )
            .then((response) => {
              Notifications.alert.success("¡Hecho!", "Corte de Caja Finalizado.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("No se pudo Finalizar", error.response.data.detail);
            });
        }
      )
    },
    validarCamposSolicitud(){
      /* Valida que todos los campos obligatorios estén llenos */
      let resultado = true;
      let listaObligatorios = []
      let motivo = document.querySelector("#motivoSolicitud");
      let tipo_correccion = document.querySelector("#tipo_correccion");
      let cantidad_solicitud = document.querySelector("#cantidad_solicitud");
      let forma_pago_solicitud = document.querySelector("#forma_pago");
      if(motivo.value.trim() === ""){
        resultado=false;
        listaObligatorios.push("Motivo de la solicitud");
      }
      if(tipo_correccion.value.trim() === ""){
        resultado=false;
        listaObligatorios.push("Tipo de Corrección");
      }
      if(cantidad_solicitud.value.trim() === ""){
        resultado=false;
        listaObligatorios.push("Total");
      }
      if(forma_pago_solicitud.value.trim() === ""){
        resultado=false;
        listaObligatorios.push("Forma de Pago");
      }
      let obligatorios = "Los siguientes campos son obligatorios: "+listaObligatorios;
      if(!resultado){this.$toast.warning(obligatorios,"Aviso",{position: 'topRight'});}
      return resultado;
    },
    guardarSolicitudCorreccion(){
      /* Guarda la solicitud de corrección */
      let self = this;
      Notifications.alert.confirm(
        "Solicitud para Corrección de Corte",
        "Se guardarán los datos ingresados, ¿Desea continuar?",
        "Si",
        function () {
          if(!self.validarCamposSolicitud()){return;}
          if(self.solicitudCorreccion.cantidad < 0){self.$toast.warning("El total debe ser mayor a 0","Aviso",{position: 'topRight'});return;}
          if ((self.solicitudCorreccion.tipo_detalle_corte == null || self.solicitudCorreccion.tipo_detalle_corte === "R") && self.solicitudCorreccion.forma_pago !== "EFECTIVO"){self.solicitudCorreccion.tipo_detalle_corte="C";}
          self.solicitudCorreccion.corte_caja = self.current.id;
          SolicitudCorreccionService.save(
            self.solicitudCorreccion
          )
            .then((response) => {
              Notifications.alert.success(
                "Generar Solicitud de Corrección",
                "Guardado correctamente"
              );
              self.solicitudCorreccion.motivo= "";
              self.solicitudCorreccion.tipo_detalle_corte= null;
              self.solicitudCorreccion.tipo_correccion= "";
              self.solicitudCorreccion.cantidad= 0;
              self.solicitudCorreccion.forma_pago= null;
              self.solicitudCorreccion.corte_caja= null;
              self.refreshSolicitudes();
            })
            .catch((errors) => {
              Notifications.alert.error(
                "Generar Solicitud de Corrección",
                errors.response.data.detail
              );
            });
        }
      )
    },
    imprimirCorte() {
      let id;
      id = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let caja = this.current.caja_id, tienda = this.current.tienda_id;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/CorteDeCaja.jrxml&Id=${id}&Caja=${caja}&Tienda=${tienda}`
      );
    },
    imprimirDetalleVenta() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/DetalleVenta_FormaPago_Caja.jrxml&Id=${self.id}`
      );
    },
    imprimirRetiroEfectivo() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/RetiroEfectivo_media_carta.jrxml&Id=${self.id}`
      );
    },
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);
      CorteCajaService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Tienda",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-tiendas-editar",
            params: { id: self.current.codigo },
          });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            self.current.errors = error.response.data;
          }
        });
    },
    generarPolizaDeCierre() {
      let self = this;
      Notifications.alert.confirm(
        "Corte de Caja",
        "¿Deseas generar la poliza de cierre de este corte?",
        "Si Generar",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja",
            self.current.id,
            "generar_poliza_de_cierre_caja"
          )
            .then((response) => {
              Notifications.alert.success(
                "Corte de Caja",
                "Poliza de Cierre generada exitosamente"
              );
              this.refreshCurrent();
            })
            .catch((errors) => {
              Notifications.alert.error(
                "Corte de Caja",
                JSON.stringify(errors.response.data)
              );
            });
        }
      );
    },
    cerrarModal() {
      $('#ModalImpresiones').modal('hide');
    },
    hide: function () {
      this.$data.destroy();
    },
    mostrarCuadreEfectivo(){
      let cuadre = document.querySelector("#cuadre");
      let total = document.querySelector("#total");
      if (this.currentDetalle.forma_pago === 'EFECTIVO'){
      cuadre.removeAttribute("hidden");
      total.setAttribute("disabled", true);
    } else {
      cuadre.setAttribute("hidden", "hidden");
      total.removeAttribute("disabled", false);
    }
    total.value = 0;
    this.currentDetalle.total = 0;
    },
    calcularTotal(){
      let montos = document.getElementsByName("montos");
      let total = document.querySelector("#total");
      let suma = 0;

      montos.forEach(monto => {
        let valor = parseInt(monto.value);
        let denominacion = parseFloat(monto.dataset.denominacion);
        suma += parseFloat(valor*denominacion);
      });
      this.currentDetalle.total = suma.toFixed(2);
      total.value = suma.toFixed(2);
    },
    verDetalles(){
      /* Función para mostrar u ocultar los detalles del corte */
      let self = this;
      self.refreshCurrent();
      self.mostrar_detalles = !self.mostrar_detalles;
      self.label_mostrar_detalles = self.mostrar_detalles ? "Ocultar detalles" : "Mostrar detalles"
    },
    aceptarCorte(){
      /* Función para aceptar el corte por parte de la persona encargada */
      let self = this;
      CorteCajaService.getAction(self.current.id,"aceptar_corte",{"usuario_acepta":self.usuario.id})
       .then((response) => {
          if (response.status === 200) {
            Notifications.alert.success(
              "Aceptar Corte de Caja",
              response.data.detail,
            );
            self.refreshCurrent();
          }
       })
       .catch(errors => {
          if(errors.response){
            Notifications.alert.error(
            "Aceptar Corte de Caja",
            errors.response.data.detail
          );
        }
      });
    },
    auditarCorte(){
      /* Función para auditar el corte */
      let self = this;
      CorteCajaService.getAction(self.current.id,"auditar_corte",{"usuario_audita":self.usuario.id})
       .then((response) => {
          if (response.status === 200) {
            Notifications.alert.success(
              "Auditar Corte de Caja",
              response.data.detail,
            );
            self.refreshCurrent();
          }
       })
       .catch(errors => {
          if(errors.response){
            Notifications.alert.error(
            "Auditar Corte de Caja",
            errors.response.data.detail
          );
        }
      });
    },
    mostrarModalSesion(auditar){
      /* Función que muestra el modal para validar el usuario */
      let self = this;
      self.auditar = auditar;
      let mensaje = self.auditar ? "¿Desea auditar este corte?\nUna vez auditado ya no se podrá regresar la operación." : "¿Desea aceptar este corte?\nUna vez aceptado ya no podrá regresar la operación."
      Notifications.alert.confirm(
        "Corte de Caja",
        mensaje,
        "Si Aceptar",
        function () {
          $("#usuarioAceptaCorteModal").modal("show");
        }
      );
    },
    async confirmarSesion(){
      /* Función que confirma la sesion y ejecuta la acción según el rol del usuario */
      let self = this;
      await AuthService.login({
        username: self.usuario.username,
        password: self.usuario.password
      }) // Se envía la solicitud de sesión con las credenciales proporcionadas
      .then(res => {
        if(res.status === 200){ // En el caso la respuesta sea éxitosa
          self.usuario.id = res.data.id; // Guardamos el id del usuario
          self.usuario.grupos = res.data.grupos; // Guardamos los grupos a los que pertenece
          if (self.usuario.grupos.some(grupo => grupo.id === self.permisos.CONTA)){ // Validamos que pertenezca al grupo de conta
            self.usuario.rol = self.roles.AUDITOR; // Se le asigna el rol de auditor
          }else if (self.usuario.grupos.some(grupo => grupo.id === self.permisos.JEFES || grupo.id === self.permisos.SUBJEFES_ASISTENTES)){ // En el caso sea Jefe o Subjefe, se le asigna el rol de encargado
            self.usuario.rol = self.roles.ENCARGADO;
          }else if (self.usuario.grupos.some(grupo => grupo.id === self.permisos.ADMINISTRADOR)){ // En el caso pertenezca al grupo de administrador
            self.usuario.rol = self.roles.ADMINISTRADOR; // Se le asigna el rol de Administrador
          }
          
          // Si el usuario no tiene ningún rol asignado, se le mostrará un mensaje de advertencia finalizando el resto del proceso
          if(self.usuario.rol == null){
            self.$toast.warning("Permisos restringidos", "No tiene los permisos necesarios para realizar la acción.", {position: 'topRight'});
            return;
          }
          
          // Validación para verificar el rol según la acción que va a realizar
          if(self.auditar && (self.usuario.rol === self.roles.ADMINISTRADOR || self.usuario.rol === self.roles.AUDITOR)){ // Si se oprimió el botón de auditar, y si tiene el rol necesario
            // Se quitan las credenciales por seguridad
            self.usuario.username = null;
            self.usuario.password = null;
            $('#usuarioAceptaCorteModal').modal('hide'); // Se oculta el modal que solicita las credenciales
            self.auditarCorte(); // Se ejecuta la función para auditar
          }else if(!self.auditar && (self.usuario.rol === self.roles.ADMINISTRADOR || self.usuario.rol === self.roles.AUDITOR || self.usuario.rol === self.roles.ENCARGADO)){ // Si se oprimió el botón de aceptar, y si tiene el rol necesario
            // Se quitan las credenciales por seguridad
            self.usuario.username = null;
            self.usuario.password = null;
            $('#usuarioAceptaCorteModal').modal('hide'); // Se oculta el modal que solicita las credenciales
            self.aceptarCorte(); // Se ejecuta la función para aceptar el corte
          }
          
        }
      })
      .catch(err => {
        if (err.response && err.response.data) { // En el caso ocurra un error
          self.errors.username = [];
          self.errors.password = [];
          self.errors.non_field_errors = err.response.data.non_field_errors || []; // Se guarda el error
          // Se muestra un mensaje indicando que ha ocurrido un error y se muestra el
          self.$toast.warning(" Revise sus Credenciales", self.errors.non_field_errors.toString(), {
            position: 'topRight'
          });
        }
      });
    },
  },
};
</script>